import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  RadioGroup,
} from '@material-ui/core';
import Button from 'components/CustomButtons/Button';
import LabeledRadio from 'components/LabeledRadio/LabeledRadio';
import SweetAlertConfirmation from 'components/SweetAlertConfirmation/SweetAlertConfirmation';

import USER_AGREEMENT_ACTIONS from '../constants/userAgreementActions';

const ConsentsDecisionModal = ({ isOpen, onClose, onSave }) => {
  const { t } = useTranslation();

  const [userAgreementAction, setUserAgreementAction] = useState(
    USER_AGREEMENT_ACTIONS.skip
  );

  const [isConfirmationAlertOpen, setIsConfirmationAlertOpen] = useState(false);

  const closeConfirmationAlert = () => {
    onClose();
    setIsConfirmationAlertOpen(false);
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        open={isOpen && !isConfirmationAlertOpen}
        onClose={onClose}
      >
        <DialogTitle>{t('brandCfg.decideAboutConsents')}</DialogTitle>
        <DialogContent>
          <RadioGroup
            value={userAgreementAction}
            onChange={e => {
              setUserAgreementAction(e.target.value);
            }}
          >
            <LabeledRadio
              label={t('brandCfg.saveConsents')}
              value={USER_AGREEMENT_ACTIONS.skip}
            />
            <LabeledRadio
              label={t('brandCfg.resetConsents')}
              value={USER_AGREEMENT_ACTIONS.clear}
            />
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>{t('common.shared.cancel')}</Button>
          <Button
            color="success"
            onClick={async () => {
              if (userAgreementAction === USER_AGREEMENT_ACTIONS.clear) {
                setIsConfirmationAlertOpen(true);
              } else {
                await onSave(userAgreementAction);
                onClose();
              }
            }}
          >
            {t('common.shared.save')}
          </Button>
        </DialogActions>
      </Dialog>
      {isConfirmationAlertOpen && (
        <SweetAlertConfirmation
          title={t('brandCfg.consentsResetConfirmation')}
          onCancel={closeConfirmationAlert}
          onConfirm={async () => {
            await onSave(userAgreementAction);
            closeConfirmationAlert();
          }}
        >
          {t('brandCfg.consentsResetConfirmationInfo')}
        </SweetAlertConfirmation>
      )}
    </>
  );
};

export default ConsentsDecisionModal;
